import { AfterViewInit, Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { BaseComponent } from '../../base/base.component';
import { NavigationStart, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../service/user.service';
import { CurrentUserGQL, User } from '../../../generated/graphql';

declare var $: any;

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class MainComponent extends BaseComponent implements OnInit, AfterViewInit {
    user: User = new User();

    constructor(public router: Router,
        public loading: NgxSpinnerService,
        public translate: TranslateService,
        private currentUserGQL: CurrentUserGQL,
        public userService: UserService) {
        super(router, loading, translate);
    }

    ngOnInit(): void {
        moment.locale('pt-br');
        if (this.userService.getStatusAuthenticated()) {
            this.getCurrentUser();
        } else {
            localStorage.clear();
            this.userService.isAuthenticated = false;
            this.router.navigate(['/logout']);
        }
    }

    ngAfterViewInit(): void {
        $(document).on('show.bs.modal', '.modal', function () {
            $(this).appendTo('body');
        });
    }

    getCurrentUser() {
        this.currentUserGQL.watch().valueChanges.subscribe(({ data }) => {
            this.user = data.currentUser as User;
            this.switchNavigate();
            this.userService.updateUser(this.user);
        });
    }

    switchNavigate() {
        const indexCountries = this.user.countries.findIndex((e) => e.name == 'Brazil');
        const isBrazil = indexCountries > -1;
        if (!isBrazil) {
            this.redirectNavigator('/links');
            this.onEventRouter('/links');
        }
        if (isBrazil) {
            this.redirectNavigator('/budget-event');
            this.onEventRouter('/budget-event');
        }
    }

    onEventRouter(router: string) {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                if (event.url == router) {
                    this.router.navigate(['/']);
                }
            }
        });
    }

    redirectNavigator(router: string) {
        if (this.router.url == router) {
            this.router.navigate(['/']);
        }
    }

}
